var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7043 0.982422C12.71 0.982422 13.6775 1.37992 14.3893 2.09317C15.1018 2.80492 15.5 3.76492 15.5 4.76992V10.6949C15.5 12.7874 13.7975 14.4824 11.7043 14.4824H4.295C2.20175 14.4824 0.5 12.7874 0.5 10.6949V4.76992C0.5 2.67742 2.19425 0.982422 4.295 0.982422H11.7043ZM12.8979 5.88742L12.9579 5.82743C13.1372 5.60992 13.1372 5.29492 12.9497 5.07743C12.8454 4.96567 12.7022 4.89742 12.5529 4.88242C12.3954 4.87417 12.2454 4.92742 12.1322 5.03242L8.75043 7.73242C8.31543 8.09317 7.69218 8.09317 7.25043 7.73242L3.87544 5.03242C3.64219 4.85992 3.31969 4.88242 3.12544 5.08492C2.92294 5.28742 2.90044 5.60992 3.07219 5.83492L3.17044 5.93242L6.58293 8.59492C7.00293 8.92492 7.51219 9.10493 8.04543 9.10493C8.57718 9.10493 9.09543 8.92492 9.51468 8.59492L12.8979 5.88742Z",
    fill: "#484848"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7043 0.982422C12.71 0.982422 13.6775 1.37992 14.3893 2.09317C15.1018 2.80492 15.5 3.76492 15.5 4.76992V10.6949C15.5 12.7874 13.7975 14.4824 11.7043 14.4824H4.295C2.20175 14.4824 0.5 12.7874 0.5 10.6949V4.76992C0.5 2.67742 2.19425 0.982422 4.295 0.982422H11.7043ZM12.8979 5.88742L12.9579 5.82743C13.1372 5.60992 13.1372 5.29492 12.9497 5.07743C12.8454 4.96567 12.7022 4.89742 12.5529 4.88242C12.3954 4.87417 12.2454 4.92742 12.1322 5.03242L8.75043 7.73242C8.31543 8.09317 7.69218 8.09317 7.25043 7.73242L3.87544 5.03242C3.64219 4.85992 3.31969 4.88242 3.12544 5.08492C2.92294 5.28742 2.90044 5.60992 3.07219 5.83492L3.17044 5.93242L6.58293 8.59492C7.00293 8.92492 7.51219 9.10493 8.04543 9.10493C8.57718 9.10493 9.09543 8.92492 9.51468 8.59492L12.8979 5.88742Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.7a07652086fca9082bd3867ffceaff2a.svg";
export { ForwardRef as ReactComponent };